import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LandingView = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const activeView = localStorage.getItem('activeView');

    if (activeView) {
      const parsedActiveView = JSON.parse(activeView);

      parsedActiveView.view === 'partner'
        ? navigate(`/partner?url=${parsedActiveView.url}`)
        : navigate(`/${parsedActiveView.view}`);
    } else {
      navigate('/');
    }
  }, [navigate]);

  return <div>Please wait...</div>;
};

export default LandingView;
